import { FileUIPart } from 'ai';
import { createContext, useContext } from 'react';
import { RachelAttachment } from '../rachel.files.types';

export interface RachelAttachmentsContextValue {
  attachments: RachelAttachment[];
  addFiles: (files: File[]) => void;
  removeAttachment: (id: string) => void;
  consumeReadyParts: (attachmentIds?: string[]) => FileUIPart[];
  hasBlockingAttachment: boolean;
}

export const RachelAttachmentsContext = createContext<RachelAttachmentsContextValue | null>(null);

export const useRachelAttachmentsContext = (): RachelAttachmentsContextValue => {
  const context = useContext(RachelAttachmentsContext);
  if (!context) {
    throw new Error('useRachelAttachmentsContext must be used within a RachelChatProvider');
  }
  return context;
};
